import { render, staticRenderFns } from "./PolizasRMSForm.vue?vue&type=template&id=0d812b0c&scoped=true&"
import script from "./PolizasRMSForm.vue?vue&type=script&lang=js&"
export * from "./PolizasRMSForm.vue?vue&type=script&lang=js&"
import style0 from "./PolizasRMSForm.vue?vue&type=style&index=0&id=0d812b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d812b0c",
  null
  
)

export default component.exports